<template>
  <card header-classes="bg-transparent" v-loading="loading">
    <div slot="header" class="row align-items-center">
      <div class="col">
        <h6 class="text-uppercase text-muted ls-1 mb-1">Postagem por Estado</h6>
      </div>
    </div>
    <bar-chart
      :height="350"
      ref="bigChart"
      :chart-data="bigBarChart.chartData"
      :extra-options="bigBarChart.extraOptions"
    ></bar-chart>
  </card>
</template>
<script>
import * as chartConfigs from "@/components/Charts/config";
import BarChart from "@/components/Charts/BarChart";
import { PrepostCountService } from "@/services/customers/prepost.count.services";

export default {
  name: "PrePostTotalByState",
  data() {
    return {
      loading: false,
      bigBarChart: {
        chartData: {
          datasets: [],
          labels: [],
        },
        extraOptions: chartConfigs.blueChartOptions,
      },
    };
  },
  components: {
    BarChart,
  },
  methods: {
    initBigChart(index) {
      const vm = this;
      vm.loading = true;
      PrepostCountService.state()
        .then((response) => {
          const chartData = {
            datasets: [
              {
                label: "Quantidade",
                data: response.values,
              },
            ],
            labels: response.labels,
          };
          this.bigBarChart.chartData = chartData;
        })
        .catch((error) => {
          this.$message({
            type: "error",
            message: error,
          });
        })
        .finally(() => (vm.loading = false));
    },
  },
  mounted() {
    this.initBigChart(0);
  },
};
</script>
